import React, { useState, useEffect, useRef } from 'react';
import 'views/pages/acm-issue/components/acm-pr-modal.scss';
import { bool, func } from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import AcmCloseIcon from 'assets/images/acm-issue/acm_close_icon.svg';
import AcmModalBannerImg from 'assets/images/acm-issue/acm_modal_banner_img.png';
import AcmModalBannerArrow from 'assets/images/acm-issue/acm_modal_banner_arrow.png';
import { getAccountId } from 'store/auth/selectors';
import { shallowEqual, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

function AcmPRModal(props) {
  const { show, onHide } = props;
  const modalRef = useRef();
  const [isShown, setIsShown] = useState(false);
  const accountId = useSelector(getAccountId, shallowEqual);

  const hanldeNavigateAcm = () => {
    if (isEmpty(accountId)) {
      return;
    }
    window.open(
      `https://docs.google.com/forms/d/e/1FAIpQLSeCv0nk9TNeV6556gOK813z3mDpttrh_VuVq_AHwVN7hy0DvA/viewform?entry.1032917813=1&entry.560226316=${accountId}`,
      '_blank'
    );
  };

  // Delay modal render to wait Ref
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShown(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div ref={modalRef} className="acm-pr-modal">
      {isShown && (
        <Modal
          centered
          show={show}
          size="w800"
          container={modalRef?.current}
          className="modal--scroll"
        >
          <Button
            className="acm-modal-close-button"
            onClick={onHide}
            id="acm-issue-modal-close"
          >
            <img src={AcmCloseIcon} className="close-icon" alt="close-icon" />
          </Button>
          <div className="acm-modal-main">
            <p className="modal-title">分析の「視点」を、AIで標準化。</p>
            <p className="modal-subtitle">
              「どこを直すべきか」の特定まで、AIにお任せ。作業はAIエージェント、判断はあなた。
            </p>
            <div className="modal-banner">
              <img
                src={AcmModalBannerImg}
                className="modal-banner-img"
                alt="modal-banner-img"
              />
              <img
                src={AcmModalBannerArrow}
                className="modal-banner-arrow"
                alt="modal-banner-arrow"
              />
            </div>
          </div>
          <div className="acm-modal-footer">
            <p className="footer-pr">
              ＼ 1ヶ月間トライアル無料！フル機能をご体験ください ／
            </p>
            <div className="acm-button-wrapper">
              <Button
                className="acm-button"
                onClick={hanldeNavigateAcm}
                id="acm-issue-modal-cv"
              >
                無料トライアルで分析フローを体験する
              </Button>
            </div>
            <p className="footer-notes">
              ※お申込み後、最短1営業日でトライアル環境をご提供いたします。
              <br />
              <span className="footer-notes-underline">
                ※トライアル期間終了後は
                <span className="footer-notes-bold">自動解約</span>
                となります。自動的に課金されることはありませんのでご安心ください。
              </span>
            </p>
          </div>
        </Modal>
      )}
    </div>
  );
}

AcmPRModal.propTypes = {
  show: bool.isRequired,
  onHide: func.isRequired,
};

export default React.memo(AcmPRModal);
